import React from 'react';
import PropTypes from 'prop-types';
import { Glyphicon } from '@bingads-webui-react/primitive';

export const DescriptionContainer = ({
  description,
}) => (
  <div className="cause-container-wrapper">
    <div className="action-container">
      <Glyphicon glyph="ba-Insights" className="fluc-lightbulb" />
    </div>
    <div className="fluc-description">{description}</div>
  </div>
);

DescriptionContainer.propTypes = {
  description: PropTypes.node.isRequired,
};
